module.exports = __webpack_public_path__ + "img/gb9457.prt.f77b8d4a.jpg";